import { useEffect, useState } from "react";
import "./theme.css";

const LAW_URL = (lawNo) =>
  encodeURI(`https://www.law.go.kr/법령/관세법/${lawNo}`);

function readArt() {
  const p = new URLSearchParams(window.location.search);
  return parseInt(p.get("art") || "", 10) || null;
}
function goArt(art) {
  const p = new URLSearchParams(window.location.search);
  p.set("audit", "exemption");
  if (art) p.set("art", art);
  else p.delete("art");
  window.history.pushState({}, "", "/?" + p.toString());
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function ExemptionPage() {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(readArt());
  const [guide, setGuide] = useState(null); // {loading}|{text,cached}|{err}
  const [guideArt, setGuideArt] = useState(null);

  useEffect(() => {
    fetch("/api/onto/exemption/list")
      .then((r) => r.json())
      .then((d) => setItems(d.items || []))
      .catch(() => setItems([]));
  }, []);
  useEffect(() => {
    const h = () => setSel(readArt());
    window.addEventListener("popstate", h);
    return () => window.removeEventListener("popstate", h);
  }, []);

  const active = items?.find((a) => a.article === sel) || null;

  const loadGuide = (art) => {
    setGuideArt(art);
    setGuide({ loading: true });
    fetch(`/api/onto/exemption/guide?art=${art}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => setGuide({ text: d.guide, cached: d.cached }))
      .catch(() => setGuide({ err: true }));
  };

  return (
    <div
      className="audit-root"
      style={{ display: "flex", height: "100%", background: "var(--audit-bg)" }}
    >
      {/* 좌: 조문 목록 */}
      <div
        style={{
          width: 300,
          borderRight: "1px solid var(--audit-border)",
          overflow: "auto",
          padding: 12,
          flexShrink: 0,
        }}
      >
        <h2 style={{ fontSize: 15, fontWeight: 800, margin: "4px 6px 10px" }}>
          관세감면 (관세법 제88~101조)
        </h2>
        {(items || []).map((a) => {
          const on = a.article === sel;
          return (
            <button
              key={a.article}
              onClick={() => goArt(a.article)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                border: "none",
                background: on ? "var(--audit-accent-bg)" : "transparent",
                cursor: "pointer",
                borderRadius: 6,
                padding: "8px 10px",
                marginBottom: 2,
                fontFamily: "inherit",
              }}
            >
              <span
                style={{
                  fontSize: 13,
                  fontWeight: on ? 700 : 500,
                  color: "var(--audit-text)",
                }}
              >
                제{a.article}조 {a.title}
              </span>
              <span
                style={{
                  marginLeft: 6,
                  fontSize: 10.5,
                  fontWeight: 700,
                  padding: "1px 5px",
                  borderRadius: 3,
                  background: a.kind === "감면" ? "#eef2ff" : "#ecfdf5",
                  color: a.kind === "감면" ? "#4338ca" : "#047857",
                }}
              >
                {a.kind}
              </span>
              <div
                style={{
                  fontSize: 11.5,
                  color: "var(--audit-text-muted)",
                  marginTop: 3,
                }}
              >
                {a.target}
              </div>
            </button>
          );
        })}
      </div>

      {/* 우: 상세 */}
      <div style={{ flex: 1, overflow: "auto", padding: "18px 22px", maxWidth: 860 }}>
        {!active ? (
          <div style={{ color: "var(--audit-text-muted)", fontSize: 13 }}>
            왼쪽에서 조문을 선택하세요.
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: 17, fontWeight: 800, margin: "0 0 4px" }}>
              관세법 제{active.article}조 · {active.title}
            </h2>
            <div
              style={{
                display: "flex",
                gap: 14,
                flexWrap: "wrap",
                fontSize: 13,
                margin: "8px 0 14px",
              }}
            >
              <div>
                <b>구분</b> {active.kind}
              </div>
              <div>
                <b>감면율</b> {active.rate}
              </div>
            </div>
            <div
              style={{
                padding: "10px 12px",
                border: "1px solid var(--audit-border)",
                borderRadius: 8,
                background: "var(--audit-bg-subtle)",
                fontSize: 13,
                lineHeight: 1.7,
                marginBottom: 14,
              }}
            >
              <b>대상</b> — {active.target}
              <div
                style={{
                  fontSize: 11.5,
                  color: "var(--audit-text-faint)",
                  marginTop: 6,
                }}
              >
                ※ 요약·참고용. 정확·최신 요건·별표·일몰은 아래 원문 확인.
              </div>
            </div>

            {/* AI 가이드 */}
            {guideArt !== active.article ? (
              <button
                onClick={() => loadGuide(active.article)}
                style={{
                  padding: "7px 14px",
                  border: "1px solid var(--audit-accent)",
                  borderRadius: 6,
                  background: "var(--audit-bg)",
                  color: "var(--audit-accent)",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                AI 가이드 보기
              </button>
            ) : guide?.loading ? (
              <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
                가이드 생성 중…
              </div>
            ) : guide?.err ? (
              <div style={{ fontSize: 13, color: "var(--audit-text-muted)" }}>
                가이드 준비 중입니다. 아래 관세청·law.go.kr 원문을 참고하세요.
              </div>
            ) : (
              <div
                style={{
                  fontSize: 13.5,
                  lineHeight: 1.75,
                  whiteSpace: "pre-wrap",
                  border: "1px solid var(--audit-border)",
                  borderRadius: 8,
                  padding: "12px 14px",
                }}
              >
                {guide?.text}
              </div>
            )}

            {/* 근거 */}
            <div style={{ marginTop: 16, display: "flex", gap: 8, flexWrap: "wrap" }}>
              <a
                href={LAW_URL(active.law_no)}
                target="_blank"
                rel="noreferrer"
                style={{
                  fontSize: 12.5,
                  padding: "5px 11px",
                  border: "1px solid var(--audit-border)",
                  borderRadius: 12,
                  color: "var(--audit-accent)",
                  textDecoration: "none",
                }}
              >
                law.go.kr — 관세법 {active.law_no} 원문 ↗
              </a>
              <a
                href="https://unipass.customs.go.kr/clip/ctensrch/openULS0401003Q.do"
                target="_blank"
                rel="noreferrer"
                style={{
                  fontSize: 12.5,
                  padding: "5px 11px",
                  border: "1px solid var(--audit-border)",
                  borderRadius: 12,
                  color: "var(--audit-accent)",
                  textDecoration: "none",
                }}
              >
                관세청 — 관세감면 안내 ↗
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
